<template>
  <a-select
    :showSearch="true"
    v-model:value="model.distributorId"
    :placeholder="title"
    style="width: 282px"
    :filter-option="false"
    :not-found-content="fetching ? undefined : null"
    @search="fetchUser"
    @change="change"
    allowClear
    :disabled="disabled"
  >
    <template v-if="fetching" v-slot:notFoundContent>
      <a-spin size="small" />
    </template>
    <a-select-option
      v-for="d in data"
      :key="d.name"
      :value="d.id"
      :label="d.businessModules"
    >
      {{ d.name }}
    </a-select-option>
  </a-select>
</template>
<script>
import shopApi from "@axios/shop";
import { ref } from "vue";
export default {
  componentname: "selectChannelShop",
  props: {
    title: {
      type: String,
      default: "请选择渠道商",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      default: function () {
        return {
          distributorId: undefined,
        };
      },
    },
  },
  setup(props, context) {
    let fetching = ref(false);
    let distributorId = ref("");

    let data = ref([]);
    console.log(props.model);
    const fetchUser = (value) => {
      let params = {
        name: value,
        currentPage: 1,
        size: 200,
      };
      fetching.value = true;
      shopApi
        .getDistributorList(params)
        .then((res) => {
          data.value = res.data;
          fetching.value = false;
        })
        .catch(() => {
          fetching.value = false;
        });
    };

    const change = (value) => {
      if (value) {
        data.value.forEach((ele) => {
          if (ele.id == value) {
            context.emit("setValue", {
              val: value,
              business: ele.businessModules,
            });
          }
        });
      } else {
        context.emit("setValue", {
          val: null,
          business: [],
        });
      }
    };

    fetchUser();

    return {
      change,
      fetchUser,
      fetching,
      distributorId,
      data,
      model: props.model,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.row_content {
  display: flex;
  justify-content: space-between;
}
</style>
